module.exports = __webpack_public_path__ + "farizon.17d760ee3e9c398c98bf.png";